import creditCardType, { types as CardType } from "credit-card-type";

import advantagePaymentTypeCodes from "./advantagePaymentTypeCodes";

export default function getPaymentMethodCode(cardNumber: string): string {
    const type = creditCardType(cardNumber);

    if (type && type[0] && type[0].type) {
        switch (type[0].type) {
            case CardType.AMERICAN_EXPRESS:
                return advantagePaymentTypeCodes.americanExpress;
            case CardType.VISA:
                return advantagePaymentTypeCodes.visa;
            case CardType.MASTERCARD:
                return advantagePaymentTypeCodes.masterCard;
            case CardType.DISCOVER:
                return advantagePaymentTypeCodes.discover;
        }
    }

    return "";
}
